// 업데이트(패치) 계산. 순수 모듈: 지금 실행 중인 표와 새 표를 견주어 "다음 접속에 실제로 받게 될 양"을 구한다.
//  - 바뀐 자산: 이 기기에 이미 받아 둔(캐시에 있는) 파일 가운데 해시가 달라진 것만 센다. 안 써 본 지역의 파일은 어차피 받지 않는다.
//  - 셸: index.html 은 늘 새로 받고, 번들(js·css)은 지금 실행 중인 번들과 이름이 다른 것(새로 받는 것)만 센다. 새 워커가 설치 중에 이미 받아 둔 번들도 업데이트 용량에 들어간다.
//    크기는 전송 크기(wire: gzip)가 있으면 그것을 쓴다.
import { hashedRel, type AssetEntry } from './assetMap';

export interface ShellFile { path: string; bytes: number; /** 전송(압축) 크기 추정 */ wire?: number }

export interface UpdatePlan {
  /** 다시 받을 파일(원래 경로) */
  changed: string[];
  assetBytes: number;
  shellBytes: number;
  total: number;
}

/**
 * @param cur 실행 중인 표(AssetEntry[])
 * @param next 새 표 { 원래 경로: "해시:바이트" }
 * @param shell 새 셸 파일 목록(asset-manifest.json 의 shell)
 * @param cachedPaths 이 기기 캐시에 든 경로 집합('/assets/h/…', '/assets/index-….js')
 * @param runningShell 지금 실행 중인 셸 번들 경로('/assets/index-….js')
 */
export function planUpdate(cur: readonly AssetEntry[], next: Readonly<Record<string, string>>, shell: readonly ShellFile[], cachedPaths: ReadonlySet<string>, runningShell: ReadonlySet<string> = new Set()): UpdatePlan {
  const curMap = new Map(cur.map((e) => [e.rel, e]));
  const changed: string[] = [];
  let assetBytes = 0;
  for (const rel of Object.keys(next)) {
    const [hash, bytesStr] = String(next[rel]).split(':');
    const old = curMap.get(rel);
    if (!old || old.hash === hash) continue;
    if (!cachedPaths.has('/assets/' + hashedRel(rel, old.hash))) continue;
    changed.push(rel);
    assetBytes += Number(bytesStr) || 0;
  }
  let shellBytes = 0;
  for (const f of shell) {
    if (f.path === 'index.html' || !runningShell.has('/' + f.path)) shellBytes += f.wire ?? f.bytes;
  }
  return { changed, assetBytes, shellBytes, total: assetBytes + shellBytes };
}

/** 사람이 읽는 크기: 1MB 미만은 KB, 그 위는 소수점 한 자리 MB */
export function formatBytes(n: number): string {
  if (n < 1024 * 1024) return Math.max(1, Math.round(n / 1024)) + ' KB';
  return (n / 1024 / 1024).toFixed(1) + ' MB';
}
